import { useState } from 'react';
import clsx from 'clsx';

import { Icon } from '@atom/mui';
import { AddIcon, CheckIcon, LibraryBooksIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { FormTemplateInfo } from '@atom/types/form';

import classes from './addFormsModal.module.css';

interface Props {
  formTemplate: FormTemplateInfo;
  subtext?: string;
  isSelected: boolean;
  availableForms: Set<string>;
  toggleFormSelect: (id: string) => void;
}

const FormRow = ({
  formTemplate,
  subtext,
  isSelected,
  toggleFormSelect,
  availableForms,
}: Props) => {
  const [selected, setSelected] = useState<boolean>(isSelected);

  const isAvailable = availableForms.has(formTemplate.id);

  const toggleForm = () => {
    toggleFormSelect(formTemplate.id);
    setSelected(!selected);
  };

  const nameStyle = (): string => {
    return clsx(
      classes.formRowTitle,
      selected && classes.selected,
      !isAvailable && classes.disabled,
    );
  };

  const subtextStyle = clsx(
    classes.titleSubtext,
    !isAvailable && classes.disabled,
  );
  const buttonIcon = selected ? CheckIcon : AddIcon;
  const iconStyle = {
    color: selected ? colors.brand.blue : colors.neutral.gray,
    cursor: 'pointer',
  };
  const iconColor = isAvailable ? colors.brand.blue : colors.neutral.silver;

  return (
    <div className={classes.formRow}>
      <div className={classes.formTitleContainer}>
        <Icon color={iconColor} icon={LibraryBooksIcon} />
        <div className={classes.formTitleContent}>
          <div className={nameStyle()}>{formTemplate.name}</div>
          <div className={subtextStyle}>{subtext}</div>
        </div>
      </div>
      {isAvailable && (
        <Icon style={iconStyle} onClick={toggleForm} icon={buttonIcon} />
      )}
    </div>
  );
};

export default FormRow;
